import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-[#FBF6EF]" data-id="element-353" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-354" data-mp="cn7t2z2b2k1g">
        <div className="text-center mb-16" data-id="element-355" data-mp="cm4yoh5rxzgs">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-[#1F4D3A]" data-id="element-356" data-mp="7qhe6f28luhm">
            THE COMPLETE <span className="text-[#9C7726]" data-id="element-357" data-mp="3g6116wcbego8">6-IN-1</span> BARTENDING &amp; MIXOLOGY INSTRUCTOR{' '}
            <span className="bg-[#C9A24B] text-[#1F4D3A] px-2 box-decoration-clone" data-id="element-358" data-mp="3c4xlc9u9okn0">ATLAS</span> SYSTEM
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-359" data-mp="3px43u2kw73pm">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-[#C9A24B] shadow-lg shadow-[#1F4D3A]/10' : 'border-slate-200 shadow-sm shadow-[#1F4D3A]/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-360" data-mp="3l27zq42dspw5" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-[#C9A24B] text-[#1F4D3A] font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-361" data-mp="1qh65n8226w9p">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-362" data-mp="20gwy74727175">
                <span className="w-12 h-12 rounded-xl bg-[#1F4D3A] text-white font-extrabold text-2xl flex items-center justify-center shrink-0 border-b-4 border-[#C9A24B]" aria-hidden="true" data-id="element-363" data-mp="24h72mcf7djjw">
                  0{index + 1}
                </span>
                <div data-id="element-364" data-mp="1gphur03b509x">
                  <div className="text-[#84651F] font-bold text-sm uppercase tracking-wider" data-id="element-365" data-mp="1gozr3iebfjrz">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-[#1F4D3A]" data-id="element-366" data-mp="1prr43mmuanlq">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-[#84651F] font-semibold mb-6 border-l-4 border-[#C9A24B] pl-4" data-id="element-367" data-mp="x222p867wljl">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-368" data-mp="16txzmfwki5m8">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-369" data-mp="120llx0tffj89">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-370" data-mp="9beracx3fdsa">
                      {volume.questions.map(question => <li key={question} className="text-[#1F4D3A] font-semibold text-sm bg-[#FBF6EF] border border-slate-200 rounded-lg px-3 py-2" data-id="element-371" data-mp="2prum2zd1smvy">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-[#1F4D3A] font-bold text-base bg-[#F5EBDD] border-l-4 border-[#C9A24B] rounded-lg px-4 py-3" data-id="element-372" data-mp="38qoy40l4n98f">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-700 text-sm leading-relaxed" data-id="element-373" data-mp="2zrbrdfoe0yre">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-374" data-mp="1ob4y0yurc54y">
                <div data-id="element-375" data-mp="1obn40n781xq2">
                  <p className="text-[#1F4D3A] font-semibold text-sm mb-3" data-id="element-376" data-mp="1o7zaho1s1bbc">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-377" data-mp="23ltf3hrlsolv">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-378" data-mp="2mjcqut5g4lbz">
                        <CheckCircle2 size={18} className="text-[#9C7726] shrink-0 mt-0.5" data-id="element-379" data-mp="2ih9fe4is1gqp" />
                        <span className="text-slate-700 text-sm" data-id="element-380" data-mp="2ifeqkf4dx4hc">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-381" data-mp="123iyfx6k6xzn">
                    <p className="text-[#1F4D3A] font-semibold text-sm mb-3" data-id="element-382" data-mp="12411bcnq8agj">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-383" data-mp="mzzqejy7755a">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-384" data-mp="rzknspxpz5fw">
                          <CheckCircle2 size={18} className="text-[#9C7726] shrink-0 mt-0.5" data-id="element-385" data-mp="wx4dqn3s56no" />
                          <span className="text-slate-700 text-sm" data-id="element-386" data-mp="11p4bqa0ahphm">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-387" data-mp="1ardkaubzz8sd">
                  {volume.sequenceIntro && <p className="text-[#1F4D3A] font-semibold text-sm mb-2" data-id="element-388" data-mp="1fmkftev45767">{volume.sequenceIntro}</p>}
                  <p className="text-[#1F4D3A] font-bold text-sm bg-[#F5EBDD] border border-slate-200 rounded-lg px-3 py-2" data-id="element-389" data-mp="3hg09kkmhz25e">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-[#FBF6EF] border border-[#E7D4AE] border-l-4 border-l-[#1F4D3A] rounded-xl p-4 mt-auto" data-id="element-390" data-mp="3edvsqjcq9a26">
                <span className="text-[#1F4D3A] font-bold block mb-1" data-id="element-391" data-mp="39gm3b3pc8yec">RESULT</span>
                {volume.resultLead && <p className="text-slate-700 text-sm" data-id="element-392" data-mp="3odwai0uy7i49">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-[#1F4D3A]" data-id="element-393" data-mp="3jfl2zws4ljp7">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-700 text-sm" data-id="element-394" data-mp="3seg793bm0jpv">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-[#9C7726]" data-id="element-395" data-mp="axyenzbg3hyk">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}